"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * extract property of a object.
 */
var PropertyExtractor = function () {
  /**
   * initialize with a object to extract.
   * @param {Object} obj
   */
  function PropertyExtractor(obj) {
    _classCallCheck(this, PropertyExtractor);

    this._obj = obj;
  }

  /**
   * extract property from package.json
   * @param {String} propertyName - to extract
   * @returns {Object} property
   */


  _createClass(PropertyExtractor, [{
    key: "extractProp",
    value: function extractProp(propertyName) {
      return this._obj[propertyName];
    }

    /**
     * extract properties from package.json
     * @param {Array} propertyNames - to extract
     * @returns {Object} has properties
     */

  }, {
    key: "extractProps",
    value: function extractProps(propertyNames) {
      var _this = this;

      return propertyNames.reduce(function (result, propertyName) {
        result[propertyName] = _this.extractProp(propertyName);
        return result;
      }, {});
    }

    /**
     * extract property's keys from package.json
     * @param {String} propertyName - to extract
     * @returns {Array} property's keys
     */

  }, {
    key: "extractPropKeys",
    value: function extractPropKeys(propertyName) {
      var property = this.extractProp(propertyName) || {};
      return Object.keys(property);
    }

    /**
     * extract properties's keys from package.json
     * @param {Array} propertyNames - to extract
     * @returns {Array} property's keys
     */

  }, {
    key: "extractPropsKeys",
    value: function extractPropsKeys(propertyNames) {
      var _this2 = this;

      var propertyKeys = propertyNames.map(function (propertyName) {
        return _this2.extractPropKeys(propertyName);
      }).reduce(function (array, propertyKeys) {
        array.push.apply(array, _toConsumableArray(propertyKeys));
        return array;
      }, []);

      return propertyKeys;
    }
  }]);

  return PropertyExtractor;
}();

module.exports = PropertyExtractor;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dpndon/dist/util/property-extractor.js
// module id = 779
// module chunks = 0